import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'
import Icon from 'components/icon/icon'
import MobileSubMenu from 'components/mobile/mobile-sub-menu'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Onboarder from 'components/onboarder/onboarder'

import { 
	openModal, 
	createOrReturnChat,
	resendInvite
} from 'state/actions'

import {
	getBaseSlugFromPath,
	getMeta,
	isMobile
} from 'utils'

import { Link } from 'react-router-dom'

import { MainContext } from 'context'

class TeamItem extends Component {
	state = {
		isForcedFocus: false
	}

	editUser = user => {
		const {
			isStakeholder,
			openModal,
			item
		} = this.props

		if(isStakeholder){
			openModal('edit','stakeholder', item)
		}else{
			openModal('edit', 'settings', {
				type: 'user',
				user: item
			})
		}
	}

	deleteUser = _ => {
		const {
			isStakeholder,
			openModal,
			type,
			currentAccount,
			item
		} = this.props

		if(isStakeholder){
			openModal('delete', 'stakeholder', { user: item })
		}else{
			openModal('delete', item.recipient_email ? 'invitation' : 'user', {
				account: currentAccount,
				type,
				user: item,
				invitation: item
			})
		}
	}

	assignProjects = _ => {
		this.props.openModal('assign', 'assign-projects', {
			user: this.props.item,
			type: 'guest'
		})
	}

	createOrReturnChat = _ => {
		const {
			item,
			createOrReturnChat
		} = this.props

		const user = item
		
		createOrReturnChat(null, user, _ => {})
	}

	resendInvite = _ => {
		const {
			openModal,
			resendInvite,
			item
		} = this.props

		openModal('confirm','confirm', {
			text: "We've re-sent this invitation"
		})

		resendInvite(item.id)
	}

	setFocus = isFocused => {
		if(this.state.isForcedFocus != isFocused){
			this.setState({
				isForcedFocus: isFocused
			})
		}
	}

	render(){
		const {
			currentAccount,
			userData,
			amAdmin,
			isGuest,
			match,
			isPremium,
			isStakeholder,
			item,
			index
		} = this.props
		
		const {
			isForcedFocus
		} = this.state

		const {
			roles
		} = this.context

		const type = item.recipient_email ? 'invitation' : 'user'

		const path = match.path

		let nameString = ''
		let emailString = ''
		let imageUrl = ''
		let role = null
		let itemClass = 'list-item '

		let userLevel = null

		if(isForcedFocus){
			itemClass += 'focused '
		}

		if(type === 'user' && item){
			if(currentAccount.adminIds.indexOf(item.id) !== -1){
				userLevel = 'Admin'
			}else if(currentAccount.pmIds.indexOf(item.id) !== -1){
				userLevel = 'Project Manager'
			}
		}

		let isMe = false

		if(type != 'invitation' && userData.id == item.id){
			isMe = true;
		}

		let controls = []

		if(isMe){
			controls.push({
				name: "fe-edit-2",
				onClick: this.editUser,
				label: 'Edit my profile'
			})
		}else{
			if(type == 'user' && !isStakeholder){
				controls.push({
					name: 'fe-mail',
					onClick: this.createOrReturnChat,
					label: 'Open chat'
				})
			}

			if(amAdmin){
				if(type === 'user'){
					if(isGuest){
						controls.push({
							name: 'star-o',
							onClick: this.assignProjects,
							label: 'Assign projects'
						})
					}else{
						controls.push({
							name: 'fe-edit-2',
							onClick: this.editUser,
							label: isStakeholder ? 'Edit stakeholder' : 'Edit user'
						})
					}
				}else{
					controls.push({
						name: 'envelope',
						onClick: this.resendInvite,
						label: 'Re-send invitation'
					})
				}

				controls.push({
					name: 'fe-trash-2',
					onClick: this.deleteUser,
					label: isStakeholder ? 'Delete stakeholder' : `Delete ${type}`
				})
			}
		}

		let newUrl = null

		switch(type){
			case 'user':
				const userObject = isMe ? userData : item

				if(userObject.first_name){
					nameString += userObject.first_name+' '
				}

				if(userObject.last_name){
					nameString += userObject.last_name
				}

				emailString = userObject.email
				imageUrl = userObject.image_url

				role = getMeta(userObject, 'role', currentAccount)

				const typeSegment = isStakeholder ? 'stakeholders' : 'staff'

				newUrl = getBaseSlugFromPath(path)+'/people/'+typeSegment+'/'+userObject.id
			break
			case 'invitation':
				nameString = this.props.item.is_guest ? "Pending guest" : 'Pending user'
				emailString = this.props.item.recipient_email
				itemClass += 'pending'
			break
		}

		const Element = (isPremium && !isMobile() && (roles.admin || roles.pm)) ? Link : props => {
			return <span {...props}>
				{ props.children }
			</span>
		}

		let mobilesubMenuOptions = []

		if(isMobile()){
			mobilesubMenuOptions = controls.map(control => {
				return {
					icon: control.name,
					label: control.label,
					callback: params => { control.onClick(params) }
				}
			})
		}

		return (
  			<li className={itemClass}>
				<Element 
					to={newUrl ? newUrl : ''}
					className={isPremium ? "team-item" : "team-item disabled"}
					style={{
						transitionDelay: (index/20)+'s'
					}}
					onClick={e => {
						if(!isPremium){
							e.preventDefault()
						}
					}}
				>
					{ !index ?
						<Onboarder type='OPENED_USER' direction="left" setFocus={this.setFocus}/>
					: null}
					<MobileSubMenu options={mobilesubMenuOptions} />
					<div className="flag-container">
						{
							isMe ?
							<span className="flag high">
								Me
							</span>
							: null
						}
						{
							userLevel ?
							<span className="flag">
								{ userLevel }
							</span>
							: null
						}
					</div>
					{ !isStakeholder ?
						<ProfilePicture 
							url={imageUrl} 
						/>
					: null }
					<div className={"user-meta"}>
						<h3>
							{ nameString ? nameString : '\u00A0' }
						</h3>
						{ isStakeholder ?
							<span>
								{ item.organisation_name }
							</span>
						: null }
						<span>
							{ emailString }
						</span>
						{ isStakeholder ?
							<span>
								{ item.phone_work }
							</span>
						: 
							<span className={ (role && role != 'null') ? 'role ': 'role no-role'}>
								{ (role && role != 'null') ? role : 'no role' }
							</span>						
						}
						<div 
							className={'team-controls length-'+controls.length}
						>
							{
								controls.map((control, i) => {
									let className = ''

									if(controls.length > 1){
										className += 'tooltip-trigger'
									}
									return(
										<button 
											className={className} 
											key={i} 
											onClick={e => {
												e.stopPropagation()
												e.preventDefault()
												control.onClick(item)
											}}
										>
											<Icon name={control.name} />
											{
												controls.length == 1 ?
												<span>
													{ control.label }
												</span>
												:		  
												<div className="tooltip top">
													{ control.label }
												</div>
											}
											
										</button>
									)
								})
							}
						</div>
					</div>
				</Element>
  			</li>
		);
	}
}

export default withRouter(connect(null, {
	openModal, 
	createOrReturnChat,
	resendInvite
})(TeamItem))

TeamItem.contextType = MainContext